<template>
  <div class="student">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <router-link target="_blank" :to="{ name: 'collegeRuleAdd'}">
              <el-button type="primary" v-if="$hasPermission([62, 173])">添加</el-button>
            </router-link>
            <el-row class="searchForm" :gutter="10">
              <el-col :span="6">
                国家：
                <el-select v-model="searchData.sh_country" placeholder="请选择" @change="changeCountry">
                  <el-option
                    v-for="item in ds.country"
                    :key="item.sh_country"
                    :label="item.title"
                    :value="item.sh_country"/>
                </el-select>
              </el-col>
              <el-col :span="6">
                院校名称：
                <jm-Search
                  clearable
                  v-model="searchData"
                  get-value="sh_name"
                  get-type="sh_name_cn"
                  :get-other-value="['sh_name', 'sh_id']"
                  :getother-type="['sh_name_cn', 'sh_id']"
                  :is-doble="true"
                  :country-id="cms_country || 0"
                  get-url='/index/api_base/searchSchool'
                />
              </el-col>
              <el-col :span="6">
                规则名称：<el-input class="jm-input220" v-model="searchData.rule_name"/>
              </el-col>
              <el-col :span="6">
                最小均分：<el-input class="jm-input220" v-model="searchData.min_result"/>
              </el-col>
              <el-col :span="6">
                状态：
                <el-select v-model="searchData.is_del">
                  <el-option :value="0" label="启用"/>
                  <el-option :value="1" label="禁用"/>
                </el-select>
              </el-col>
            </el-row>
            <el-row class="jm-tac" :gutter="10">
              <el-col :span="24">
                <el-button type="primary" @click="init">搜索</el-button>
              </el-col>
            </el-row>
            <jm-tableList
              v-if="searchData"
              url="/index/u_u_college_rule/getList"
              :refresh="refresh"
              :search-data="searchData">
              <el-table-column
                slot="firstColumn"
                type="expand">
                <template slot-scope="props">
                  <div>毕业院校：{{ props.row.cn_sh_name }}</div>
                </template>
              </el-table-column>
              <el-table-column
                slot="min_result"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label"
                property="min_result">
                <template slot-scope="scope">
                  {{ scope.row.min_result }}
                  <span class="blue" v-if="scope.row.stand_result !== ''">({{ scope.row.stand_result }})</span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                slot="lastColumn"
                label="操作"
                min-width="150"
                v-if="$hasPermission([62, 173])">
                <template slot-scope="scope">
                  <el-button type="danger" @click="changeStauts(scope.row)">{{ scope.row.is_del === '禁用' ?'开启':'禁用' }}</el-button>
                  <router-link
                    target="_blank"
                    :to="{ name: 'collegeRuleEdit', params: { id: scope.row.id }}">
                    <el-button type="primary">编辑</el-button>
                  </router-link>
                </template>
              </el-table-column>
            </jm-tableList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { jmSearch } from '@/components/tool';
import jmTableList from '@/components/data/tableList';

export default {
  data() {
    return {
      ds: {},
      refresh: false,
      searchData: {
        rule_name: '',
        min_result: '',
        sh_country: 1,
        sh_id: '',
        is_del: 0
      },
      cms_country: 0,
      timeout: null,
    };
  },
  components: { jmTableList, jmSearch },
  created() {
    this.$http
      ._get({
        url: '/index/u_u_college_rule/searchDict'
      })
      .then(({ data }) => {
        this.ds = Object.assign({}, this.ds, data);
        this.searchData.sh_country = typeof this.ds.country === 'object' ? this.ds.country[0].sh_country : 1;
        this.cms_country = typeof this.ds.country === 'object' ? this.ds.country[0].cms_country : 30;
        this.init();
      });
  },
  methods: {
    init() {
      this.$store.commit('updateRefresh', true);
    },
    setChartsSort() {
      this.chartsData = this.sortData(this.chartsData, this.chartsSort.value);
    },
    changeCountry() {
      this.ds.country.forEach((i) => {
        if (this.formData.sh_country === i.sh_country) {
          this.cms_country = i.cms_country;
        }
      });
    },
    changeStauts(post) {
      let data = { id: post.id, is_del: 0 };
      data.is_del = post.is_del === '启用' ? 1 : 0;
      this.$http
        ._post({
          url: '/index/u_u_college_rule/isDel',
          data
        })
        .then(() => {
          this.init();
        });
    }
  },
  watch: {
    // searchData: {
    //   handler: function () {
    //     clearTimeout(this.timeout);
    //     this.timeout = setTimeout(() => {
    //       this.$nextTick(this.init);
    //     }, 500);
    //   },
    //   deep: true
    // }
  }
};

</script>

<style scoped>
#main-content {
  background-color: #f3f3f3;
}

.s_right {
  float: right;
}

.searchForm *{
  padding: 5px;
}

.rows {
  margin-top: 10px;
  margin-bottom: 30px;
}

.rows .rows-div {
  background-color: #FFF;
  border-radius: 5px;
  padding: 10px 20px 20px 20px;
}

.rows .rows-div p {
  border-bottom: solid 1px #CCC;
  padding: 10px 0px;
}

.rows .rows-div .chart-div {
  height: 250px;
}

.s_title {
  font-size: 18px;
}

.blue {
  color: #409EFF;
}
</style>
